/*
 * Unified Cart AJAX
 * ------------------
 * Handles add/remove for downloadable MP3/MP4 products (which must only be
 * addable once per cart) without leaving the current page.
 *
 * Physical products are NOT handled here — they go through the separate global
 * `.addtocart` click handler further down in this file, which Ajax-posts
 * #add-item-form and plays the cart-animation. To keep the two code paths from
 * firing together, downloadable buttons deliberately DO NOT carry the
 * .addtocart class.
 *
 * Button class contract:
 *   .addtocart                — physical-product "Add to cart" (.addtocart handler below)
 *   .js-downloadable-add      — downloadable "Add to cart" (product page)
 *   .js-remove-from-cart      — downloadable "Remove from Cart" (product page)
 *   .quick-add-btn            — toggling "+"/"✓" on collection / product-loop pages
 *   .btn                      — shared visual style for every cart button
 */
window.CartAjax = (function($) {
  // variantId -> lineItemId for items currently in the cart.
  // Populated by initCartState() on page load and kept in sync on add/remove
  // so we can render buttons in the right state without a server round-trip.
  var cartLineItemIds = {};

  function updateCartCount(delta) {
    var current = parseInt($('#cart-count').text(), 10) || 0;
    var next = Math.max(0, current + delta);
    $('#cart-count').text(next);
    $('#cart-target').toggleClass('has-items', next > 0);
  }

  // Helper: set a button's visible label. <input> uses value, everything else uses text.
  function setBtnLabel($btn, label) {
    if (!$btn || !$btn.length) return;
    if ($btn.is('input')) $btn.val(label);
    else $btn.text(label);
  }

  function addToCart(variantId, callbacks) {
    callbacks = callbacks || {};
    var $btn = callbacks.$btn;
    var quantity = callbacks.quantity || 1;
    if ($btn) {
      $btn.prop('disabled', true);
      if (callbacks.loadingText) setBtnLabel($btn, callbacks.loadingText);
    }

    $.ajax({
      type: 'POST', url: '/cart/add.js', dataType: 'json',
      data: { id: variantId, quantity: quantity },
      success: function(data) {
        var lineId = data.line_item ? data.line_item.id : data.variant_id;
        cartLineItemIds[variantId] = lineId;
        updateCartCount(quantity);
        if (callbacks.onSuccess) callbacks.onSuccess($btn, variantId, lineId, data);
      },
      error: function(xhr) {
        if ($btn) {
          $btn.prop('disabled', false).attr('title', 'Add to cart');
          if (callbacks.addText) setBtnLabel($btn, callbacks.addText);
        }
        if (callbacks.onError) callbacks.onError($btn, xhr);
      }
    });
  }

  function removeFromCart(lineId, variantId, callbacks) {
    callbacks = callbacks || {};
    var $btn = callbacks.$btn;
    if ($btn) $btn.prop('disabled', true);

    $.ajax({
      type: 'POST', url: '/cart/change.js', dataType: 'json',
      data: { id: lineId, quantity: 0 },
      success: function() {
        delete cartLineItemIds[variantId];
        updateCartCount(-1);
        if (callbacks.onSuccess) callbacks.onSuccess($btn, variantId, lineId);
      },
      error: function(error) {
        console.log('Error removing item:', error);
        if ($btn) $btn.prop('disabled', false);
        if (callbacks.onError) callbacks.onError($btn);
      }
    });
  }

  // Reflect cart contents in any .quick-add-btn already on the page
  // (the server-side `product.liquid` already renders the right button for
  // the main product page, so this is only needed for collection/loop views).
  function markButtonsInCart() {
    $('.quick-add-btn').each(function() {
      var $btn = $(this);
      var lineId = cartLineItemIds[$btn.data('variant-id')];
      if (lineId) {
        $btn.addClass('added').text('✓').attr('title', 'Remove from cart')
            .attr('data-line-id', lineId).data('line-id', lineId);
      }
    });
  }

  function initCartState() {
    $.ajax({
      type: 'GET', url: '/cart.js', dataType: 'json',
      success: function(cart) {
        if (!cart.items || !cart.items.length) return;
        $.each(cart.items, function(_, item) { cartLineItemIds[item.variant_id] = item.id; });
        var count = cart.items.reduce(function(sum, item) { return sum + item.quantity; }, 0);
        $('#cart-count').text(count);
        $('#cart-target').toggleClass('has-items', count > 0);
        markButtonsInCart();
      }
    });
  }

  return {
    addToCart: addToCart,
    removeFromCart: removeFromCart,
    updateCartCount: updateCartCount,
    getLineItemId: function(variantId) { return cartLineItemIds[variantId]; },
    init: initCartState,
    markButtonsInCart: markButtonsInCart
  };
})(jQuery);

$(document).ready(function($) {
  CartAjax.init();

  /*
   * Physical-product add-to-cart (.addtocart)
   * -----------------------------------------
   * Reuses CartAjax.addToCart (respecting the quantity field) and plays the
   * bezier "fly to cart" animation. Physical products CAN be added multiple
   * times, so the button is never swapped for a "Remove" button. Only physical
   * buttons carry the .addtocart class — downloadable items use
   * .js-downloadable-add and are handled by the toggle handlers below.
   */
  $('.addtocart').on('click', function(e) {
    e.preventDefault();
    var $btn = $(this);
    var quantity = parseInt($('[name="quantity"]').val(), 10) || 1;
    CartAjax.addToCart($('#product-select').val(), {
      $btn: $btn,
      quantity: quantity,
      // CartAjax already bumped #cart-count; this just animates and re-enables.
      onSuccess: function($btn) { flyToCart($btn, quantity); },
      onError: showCartError
    });
  });

  // Animate a badge from the button along a bezier path to the cart icon.
  function flyToCart($btn, quantity) {
    $('html, body').animate({ scrollTop: 0 }, 250, 'swing');
    $('#cart-animation').show();

    var startX = $btn.offset().left + $btn.outerWidth() / 2;
    var startY = $btn.offset().top + $btn.outerHeight() / 2;
    var $target = $('#cart-target');
    var targetW = $target.outerWidth();
    var endX = ($target.offset().left + targetW / 2 - $('#cart-animation').outerWidth() / 2) - 4 - 18;
    var endY = ($target.offset().top + targetW / 2 - $('#cart-animation').outerHeight() / 2) - 4 - 8;

    var path = {
      start: { x: startX, y: startY, angle: 190.012, length: 0.2 },
      end:   { x: endX,   y: endY,   angle: 90.012,  length: 0.50 }
    };

    $('#cart-animation').text(quantity).animate(
      { path: new $.path.bezier(path) },
      1200,
      function() {
        $('#cart-animation').fadeOut(500, function() { $btn.prop('disabled', false); });
      }
    );
  }

  // Surface Shopify's cart error (e.g. "sold out") to the shopper.
  function showCartError($btn, xhr) {
    var data = xhr && xhr.responseJSON;
    if (!data) { try { data = JSON.parse(xhr.responseText); } catch (e) { data = {}; } }
    alert(data.message ? data.message + ' (' + data.status + '): ' + data.description : 'Error adding to cart.');
  }

  /*
   * Product-page toggle (downloadable items)
   * ----------------------------------------
   * The two delegated handlers below form a single toggle: each replaces
   * itself in the DOM with the opposite button on success. We use document
   * delegation so the new button is still wired up after a swap.
   */
  // Using <input type="button"> (not <button>) to inherit the existing
  // `input.btn` styling rules in styles.scss.liquid.
  function makeRemoveBtn(variantId, lineId) {
    return $('<input type="button">')
      .addClass('btn js-remove-from-cart')
      .val('Remove from Cart')
      .attr('data-variant-id', variantId)
      .attr('data-line-id', lineId);
  }
  function makeAddBtn() {
    return $('<input type="button">')
      .addClass('btn js-downloadable-add')
      .val('Add to cart');
  }

  $(document).on('click', '.js-downloadable-add', function(e) {
    e.preventDefault();
    var $btn = $(this);
    if ($btn.prop('disabled')) return;
    // Read the currently-selected variant from the product page's <select>.
    var variantId = $('#product-select').val();
    CartAjax.addToCart(variantId, {
      $btn: $btn, loadingText: '...', addText: 'Add to cart',
      onSuccess: function($btn, variantId, lineId) {
        $btn.replaceWith(makeRemoveBtn(variantId, lineId));
      }
    });
  });

  $(document).on('click', '.js-remove-from-cart', function(e) {
    e.preventDefault();
    var $btn = $(this);
    if ($btn.prop('disabled')) return;
    CartAjax.removeFromCart($btn.data('line-id'), $btn.data('variant-id'), {
      $btn: $btn,
      onSuccess: function($btn, variantId) {
        $btn.replaceWith(makeAddBtn());
        // If a .quick-add-btn for the same variant exists elsewhere on the
        // page (e.g. in a related-products loop), reset it too.
        $('.quick-add-btn[data-variant-id="' + variantId + '"]')
          .removeClass('added').text('+').attr('title', 'Add to cart')
          .prop('disabled', false).removeAttr('data-line-id').removeData('line-id');
      }
    });
  });

  /*
   * Collection / product-loop toggle (.quick-add-btn)
   * Swaps "+" <-> "✓" in place rather than replacing the element so the
   * button's absolute positioning (see product-loop.liquid) is preserved.
   */
  $('.quick-add-btn').on('click', function(e) {
    e.preventDefault();
    var $btn = $(this);
    var variantId = $btn.data('variant-id');

    if ($btn.hasClass('added')) {
      CartAjax.removeFromCart($btn.data('line-id'), variantId, {
        $btn: $btn,
        onSuccess: function($btn) {
          $btn.removeClass('added').text('+').attr('title', 'Add to cart')
              .prop('disabled', false).removeAttr('data-line-id').removeData('line-id');
        }
      });
    } else {
      CartAjax.addToCart(variantId, {
        $btn: $btn, loadingText: '...', addText: '+',
        onSuccess: function($btn, variantId, lineId) {
          $btn.addClass('added').text('✓').prop('disabled', false)
              .attr('title', 'Remove from cart')
              .attr('data-line-id', lineId).data('line-id', lineId);
        }
      });
    }
  });
});

jQuery(window).load(function(){

  if ( $('.slides li').size() > 1 ) {

    $('.flexslider').flexslider({
      animation: "slide",
      slideshow: true,
      animationDuration: 700,
      slideshowSpeed: 6000,
      animation: "fade",
      controlsContainer: ".flex-controls",
      controlNav: false,
      keyboardNav: true
    }).hover(function(){ $('.flex-direction-nav').fadeIn();}, function(){$('.flex-direction-nav').fadeOut();});

  }

  $("select.loc_on_change").change(function(){
  	if($(this).attr("value") == "#") return false;
  	window.location = $(this).attr("value");
  });

});

/*============================*/
/* Update main product image. */
/*============================*/
var switchImage = function(newImageSrc, newImage, mainImageDomEl) {
  // newImageSrc is the path of the new image in the same size as originalImage is sized.
  // newImage is Shopify's object representation of the new image, with various attributes, such as scr, id, position.
  // mainImageDomEl is the passed domElement, which has not yet been manipulated. Let's manipulate it now.
  jQuery(mainImageDomEl).attr('src', newImageSrc);
  
  $(mainImageDomEl).parents('a').attr('href', newImageSrc);
  
};


jQuery(document).ready(function($){
    	
  $("a.zoom").fancybox({
    padding:0,
    'titleShow': false,
    overlayColor: '#000000',
    overlayOpacity: 0.2
  });

  /* Update main product image when a thumbnail is clicked. */
  /*==========================*/
  $('#product .thumbs a').on('click', function(e) { 
    e.preventDefault();
    switchImage($(this).attr('href'), null, $('.featured img')[0]);
  } );
  
  

  $("nav.mobile select").change(function(){ window.location = jQuery(this).val(); });
   
  $('input[type="submit"], input.btn, button').click(function(){ // remove ugly outline on input button click
    $(this).blur();
  })
  
  $("li.dropdown").hover(function(){
    $(this).children('.dropdown').show();
    $(this).children('.dropdown').stop();
    $(this).children('.dropdown').animate({
      opacity: 1.0
    }, 200);
  }, function(){
    $(this).children('.dropdown').stop();
    $(this).children('.dropdown').animate({
      opacity: 0.0
    }, 400, function(){
      $(this).hide();
    });
  });
  
  $('a[href^="#"]').bind('click.smoothscroll',function (e) {

    e.preventDefault();
    
    var target = this.hash,
        $target = $(target);
    
    $('html, body').stop().animate({
        'scrollTop': $target.offset().top
    }, 500, 'swing', function () {
        window.location.hash = target;
    });
  });
  
  var tabs = $('ul.tabs > li > a');
  tabs.each(function(i) {
    jQuery(this).unbind('click.smoothscroll')
    .click(function(e) {
         var contentLocation = $(this).attr('href');
    	 if(contentLocation.charAt(0)=="#") {            
  		tabs.removeClass('active');
  		$(this).addClass('active');
  		$(contentLocation).show().addClass('active').siblings().hide().removeClass('active');
    	 }
      return false;
    });
  });
  
}); // end document ready

/* jQuery css bezier animation support -- Jonah Fox */
 
;(function($){
 
  $.path = {};
 
  var V = {
    rotate: function(p, degrees) {
      var radians = degrees * Math.PI / 180,
        c = Math.cos(radians),
        s = Math.sin(radians);
      return [c*p[0] - s*p[1], s*p[0] + c*p[1]];
    },
    scale: function(p, n) {
      return [n*p[0], n*p[1]];
    },
    add: function(a, b) {
      return [a[0]+b[0], a[1]+b[1]];
    },
    minus: function(a, b) {
      return [a[0]-b[0], a[1]-b[1]];
    }
  };
 
  $.path.bezier = function( params, rotate ) {
    params.start = $.extend( {angle: 0, length: 0.3333}, params.start );
    params.end = $.extend( {angle: 0, length: 0.3333}, params.end );
 
    this.p1 = [params.start.x, params.start.y];
    this.p4 = [params.end.x, params.end.y];
 
    var v14 = V.minus( this.p4, this.p1 ),
      v12 = V.scale( v14, params.start.length ),
      v41 = V.scale( v14, -1 ),
      v43 = V.scale( v41, params.end.length );
 
    v12 = V.rotate( v12, params.start.angle );
    this.p2 = V.add( this.p1, v12 );
 
    v43 = V.rotate(v43, params.end.angle );
    this.p3 = V.add( this.p4, v43 );
 
    this.f1 = function(t) { return (t*t*t); };
    this.f2 = function(t) { return (3*t*t*(1-t)); };
    this.f3 = function(t) { return (3*t*(1-t)*(1-t)); };
    this.f4 = function(t) { return ((1-t)*(1-t)*(1-t)); };
 
    /* p from 0 to 1 */
    this.css = function(p) {
      var f1 = this.f1(p), f2 = this.f2(p), f3 = this.f3(p), f4=this.f4(p), css = {};
      if (rotate) {
        css.prevX = this.x;
        css.prevY = this.y;
      }
      css.x = this.x = ( this.p1[0]*f1 + this.p2[0]*f2 +this.p3[0]*f3 + this.p4[0]*f4 +.5 )|0;
      css.y = this.y = ( this.p1[1]*f1 + this.p2[1]*f2 +this.p3[1]*f3 + this.p4[1]*f4 +.5 )|0;
      css.left = css.x + "px";
      css.top = css.y + "px";
      return css;
    };
  };
 
  $.path.arc = function(params, rotate) {
    for ( var i in params ) {
      this[i] = params[i];
    }
 
    this.dir = this.dir || 1;
 
    while ( this.start > this.end && this.dir > 0 ) {
      this.start -= 360;
    }
 
    while ( this.start < this.end && this.dir < 0 ) {
      this.start += 360;
    }
 
    this.css = function(p) {
      var a = ( this.start * (p ) + this.end * (1-(p )) ) * Math.PI / 180,
        css = {};
 
      if (rotate) {
        css.prevX = this.x;
        css.prevY = this.y;
      }
      css.x = this.x = ( Math.sin(a) * this.radius + this.center[0] +.5 )|0;
      css.y = this.y = ( Math.cos(a) * this.radius + this.center[1] +.5 )|0;
      css.left = css.x + "px";
      css.top = css.y + "px";
      return css;
    };
  };
 
  $.fx.step.path = function(fx) {
    var css = fx.end.css( 1 - fx.pos );
    if ( css.prevX != null ) {
      $.cssHooks.transform.set( fx.elem, "rotate(" + Math.atan2(css.prevY - css.y, css.prevX - css.x) + ")" );
    }
    fx.elem.style.top = css.top;
    fx.elem.style.left = css.left;
  };
 
})(jQuery);
